import { Injectable } from '@angular/core';
import {
  ActivatedRoute,
  ActivatedRouteSnapshot,
  CanActivate,
  Router,
  RouterStateSnapshot,
  UrlTree,
} from '@angular/router';
import { AccountService } from 'app/core';
import { getSubdomain, isGuid } from 'app/shared/Utils/common.utils';
import { Observable } from 'rxjs';
import { map, switchMap } from 'rxjs/operators';
import { ProjectsService } from '../projects/projects.service';
import { PropertiesDetailsComponent } from './details/details.component';
import { PropertiesService } from './properties.service';
@Injectable({
  providedIn: 'root',
})
export class CanDeactivatePropertiesDetails {
  canDeactivate(
    component: PropertiesDetailsComponent,
    currentRoute: ActivatedRouteSnapshot,
    currentState: RouterStateSnapshot,
    nextState: RouterStateSnapshot,
  ): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    // Get the next route
    let nextRoute: ActivatedRouteSnapshot = nextState.root;
    while (nextRoute.firstChild) {
      nextRoute = nextRoute.firstChild;
    }

    // If the next state doesn't contain '/contacts'
    // it means we are navigating away from the
    // contacts app
    if (!nextState.url.includes('/properties')) {
      // Let it navigate
      return true;
    }

    /*
        hiding for now, since we do not allow editing a task within a contact
        if ( !nextRoute.paramMap.get('task_id') ) {
            return component.closeDrawer().then(() => {
                return true;
            });
        }*/

    // If we are navigating to another contact...
    if (nextRoute.paramMap.get('id')) {
      // Just navigate
      return true;
    }
    // Otherwise...
    else {
      // Close the drawer first, and then navigate
      //return component.closeDrawer().then(() => {
      return true;
      //});
    }
  }
}

@Injectable({
  providedIn: 'root',
})
export class CanActivatePropertiesDetails {
  staticTabsRouteReference: { [key: string]: string } = {
    Files: 'folders',
    'Loan Quotes': 'loans',
  };

  constructor(
    private readonly _activatedRoute: ActivatedRoute,
    private readonly _router: Router,
    private readonly _projectService: ProjectsService,
    private readonly _accountService: AccountService,
  ) {}

  canActivate(next: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    if (/(\/properties\/\d+)$/g.test(state.url)) {
      const { id: propertyId } = next.params;

      return this._accountService.getAccount(getSubdomain()).pipe(
        switchMap((account) =>
          this._projectService.getProjectTemplateByRelatedToId(propertyId, 'Property', account?.id),
        ),
        map((template) => {
          if (template.definition?.dashboard?.header) {
            const [firstTab] = template.definition?.dashboard?.header;
            if (!isGuid(firstTab)) {
              this._router.navigate(
                [
                  'properties',
                  propertyId,
                  'details',
                  this.staticTabsRouteReference[firstTab] ?? firstTab.toLowerCase(),
                ],
                { relativeTo: this._activatedRoute },
              );
            } else {
              this._router.navigate(['properties', propertyId, 'details', 'tabs', firstTab], {
                relativeTo: this._activatedRoute,
              });
            }
          } else {
            this._router.navigate(['properties', propertyId, 'details', 'overview'], {
              relativeTo: this._activatedRoute,
            });
          }

          return true;
        }),
      );
    }
    return true;
  }
}

@Injectable({
  providedIn: 'root',
})
export class PropertyTabExistsGuard implements CanActivate {
  constructor(private propertyService: PropertiesService, private router: Router) {}

  canActivate(route: ActivatedRouteSnapshot): Observable<boolean | UrlTree> {
    const tabId = route.params['tab_id'];
    const propertyId = route.params['id'];
    const overviewPath = ['/properties', propertyId, 'details', 'overview'];

    return this.propertyService.getPropertyById(propertyId).pipe(
      map((property) => {
        if (!property.template?.definition?.dashboard?.tabs) {
          return this.router.createUrlTree(overviewPath);
        }

        const tabExists = property.template.definition.dashboard.tabs.some((tab) => tab.id === tabId);

        return tabExists ? true : this.router.createUrlTree(overviewPath);
      }),
    );
  }
}
